
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 234","transform":"translate(-3310 886)"}},[_c('circle',{attrs:{"data-name":"楕円形 4","cx":"16","cy":"16","r":"16","transform":"translate(3310 -886)","fill":"#127efd"}}),_c('path',{attrs:{"data-name":"bullhorn (1)","d":"M3326.231-874.765h-7.385a2 2 0 00-1.846 2.118v4.235a2 2 0 001.846 2.118h.923v4.235a1 1 0 00.923 1.059h1.846a1 1 0 00.923-1.059v-4.235h2.769l4.615 4.235V-879l-4.614 4.235m8.769 4.236a4.779 4.779 0 01-2.308 4.235v-8.471a4.823 4.823 0 012.308 4.236z","fill":"#fff"}})])])
          )
        }
      }
    